(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './androidx-compose-runtime-runtime.js', './androidx-collection-collection.js', './androidx-compose-runtime-runtime-saveable.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./androidx-compose-runtime-runtime.js'), require('./androidx-collection-collection.js'), require('./androidx-compose-runtime-runtime-saveable.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'androidx-navigation3-navigation3-runtime'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'androidx-navigation3-navigation3-runtime'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'androidx-navigation3-navigation3-runtime'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'androidx-navigation3-navigation3-runtime'.");
    }
    if (typeof globalThis['androidx-collection-collection'] === 'undefined') {
      throw new Error("Error loading module 'androidx-navigation3-navigation3-runtime'. Its dependency 'androidx-collection-collection' was not found. Please, check whether 'androidx-collection-collection' is loaded prior to 'androidx-navigation3-navigation3-runtime'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime-saveable'] === 'undefined') {
      throw new Error("Error loading module 'androidx-navigation3-navigation3-runtime'. Its dependency 'androidx-compose-runtime-runtime-saveable' was not found. Please, check whether 'androidx-compose-runtime-runtime-saveable' is loaded prior to 'androidx-navigation3-navigation3-runtime'.");
    }
    globalThis['androidx-navigation3-navigation3-runtime'] = factory(typeof globalThis['androidx-navigation3-navigation3-runtime'] === 'undefined' ? {} : globalThis['androidx-navigation3-navigation3-runtime'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-compose-runtime-runtime'], globalThis['androidx-collection-collection'], globalThis['androidx-compose-runtime-runtime-saveable']);
  }
}(function (_, kotlin_kotlin, kotlin_androidx_compose_runtime_runtime, kotlin_androidx_collection_collection, kotlin_androidx_compose_runtime_runtime_saveable) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var emptyList = kotlin_kotlin.$_$.c9;
  var toList = kotlin_kotlin.$_$.kc;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.z3;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var RandomAccess = kotlin_kotlin.$_$.m7;
  var isInterface = kotlin_kotlin.$_$.rg;
  var Companion_getInstance = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var rememberUpdatedState = kotlin_androidx_compose_runtime_runtime.$_$.g2;
  var rememberComposableLambda = kotlin_androidx_compose_runtime_runtime.$_$.c;
  var DisposableEffect = kotlin_androidx_compose_runtime_runtime.$_$.p;
  var KProperty0 = kotlin_kotlin.$_$.xi;
  var getLocalDelegateReference = kotlin_kotlin.$_$.wf;
  var reversed = kotlin_kotlin.$_$.pb;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var DisposableEffect_0 = kotlin_androidx_compose_runtime_runtime.$_$.q;
  var updateChangedFlags = kotlin_androidx_compose_runtime_runtime.$_$.q2;
  var distinct = kotlin_kotlin.$_$.z8;
  var MutableScatterSet = kotlin_androidx_collection_collection.$_$.o;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var equals = kotlin_kotlin.$_$.sf;
  var hashCode = kotlin_kotlin.$_$.bg;
  var toString = kotlin_kotlin.$_$.hh;
  var composableLambdaInstance = kotlin_androidx_compose_runtime_runtime.$_$.b;
  var rememberSaveableStateHolder = kotlin_androidx_compose_runtime_runtime_saveable.$_$.g;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(decorateEntry$$inlined$run$1$1$1);
  initMetadataForClass(PrepareBackStack$$inlined$fastForEachOrForEach$1$1);
  initMetadataForClass(PrepareBackStack$$inlined$fastForEachOrForEach$2$1);
  initMetadataForClass(NavEntry, 'NavEntry');
  initMetadataForClass(NavEntryDecorator, 'NavEntryDecorator');
  initMetadataForClass(SaveableStateHolderNavEntryDecorator, 'SaveableStateHolderNavEntryDecorator', VOID, NavEntryDecorator);
  //endregion
  function rememberDecoratedNavEntries(backStack, entryDecorators, entryProvider, $composer, $changed, $default) {
    var entryDecorators_0 = entryDecorators;
    var $composer_0 = $composer;
    if (!(($default & 2) === 0)) {
      // Inline function 'kotlin.collections.listOf' call
      entryDecorators_0 = emptyList();
    }
    var tmp1_remember$arg$0 = toList(backStack);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.k31(tmp1_remember$arg$0);
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      // Inline function 'androidx.navigation3.runtime.fastMapOrMap' call
      var tmp_0;
      if (isInterface(backStack, RandomAccess)) {
        var target = ArrayList_init_$Create$(backStack.n1());
        var inductionVariable = 0;
        var last = backStack.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = backStack.l1(index);
            // Inline function 'kotlin.collections.plusAssign' call
            var element = entryProvider(item);
            target.j1(element);
          }
           while (inductionVariable <= last);
        tmp_0 = target;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(backStack, 10));
        var _iterator__ex2g4s = backStack.t();
        while (_iterator__ex2g4s.u()) {
          var item_0 = _iterator__ex2g4s.v();
          var tmp$ret$13 = entryProvider(item_0);
          destination.j1(tmp$ret$13);
        }
        tmp_0 = destination;
      }
      var value = tmp_0;
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var entries = tmp;
    return rememberDecoratedNavEntries_0(entries, entryDecorators_0, $composer_0, 112 & $changed, 0);
  }
  function rememberDecoratedNavEntries_0(entries, entryDecorators, $composer, $changed, $default) {
    var entryDecorators_0 = entryDecorators;
    var $composer_0 = $composer;
    if (!(($default & 2) === 0)) {
      // Inline function 'kotlin.collections.listOf' call
      entryDecorators_0 = emptyList();
    }
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      // Inline function 'kotlin.collections.mutableSetOf' call
      var value = LinkedHashSet_init_$Create$();
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var keysInBackstack = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (false || it_0 === Companion_getInstance().f30_1) {
      // Inline function 'kotlin.collections.mutableSetOf' call
      var value_0 = LinkedHashSet_init_$Create$();
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var keysInComposition = tmp_0;
    $composer_0.m30(110758886);
    // Inline function 'androidx.navigation3.runtime.fastMapOrMap' call
    var tmp_1;
    if (isInterface(entries, RandomAccess)) {
      var target = ArrayList_init_$Create$(entries.n1());
      var inductionVariable = 0;
      var last = entries.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = entries.l1(index);
          // Inline function 'kotlin.collections.plusAssign' call
          var element = decorateEntry(item, entryDecorators_0, keysInBackstack, keysInComposition, $composer_0, 112 & $changed);
          target.j1(element);
        }
         while (inductionVariable <= last);
      tmp_1 = target;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(entries, 10));
      var _iterator__ex2g4s = entries.t();
      while (_iterator__ex2g4s.u()) {
        var item_0 = _iterator__ex2g4s.v();
        var tmp$ret$19 = decorateEntry(item_0, entryDecorators_0, keysInBackstack, keysInComposition, $composer_0, 112 & $changed);
        destination.j1(tmp$ret$19);
      }
      tmp_1 = destination;
    }
    var tmp1_group = tmp_1;
    $composer_0.n30();
    var decoratedEntries = tmp1_group;
    PrepareBackStack(decoratedEntries, entryDecorators_0, keysInBackstack, keysInComposition, $composer_0, 112 & $changed);
    return decoratedEntries;
  }
  function decorateEntry(entry, decorators, keysInBackstack, keysInComposition, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.m30(-1239021605);
    var latestDecorators$delegate = rememberUpdatedState(decorators, $composer_0, 14 & $changed >> 3);
    var contentKey = entry.tmu_1;
    $composer_0.o30(-993800456, contentKey);
    // Inline function 'kotlin.run' call
    var dispatchReceiver = rememberComposableLambda(-1349345695, true, decorateEntry$lambda_0(keysInComposition, contentKey, keysInBackstack, latestDecorators$delegate, decorators, entry), $composer_0, 54);
    // Inline function 'androidx.compose.runtime.remember' call
    var $composer_1 = $composer_0;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_1.k31(dispatchReceiver);
    // Inline function 'kotlin.let' call
    var it = $composer_1.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = ComposableLambda$invoke$ref(dispatchReceiver);
      $composer_1.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp$ret$0 = tmp;
    var tmp0_return = NavEntry_init_$Create$(entry, tmp$ret$0);
    $composer_0.p30();
    $composer_0.n30();
    return tmp0_return;
  }
  function PrepareBackStack(entries, decorators, keysInBackstack, keysInComposition, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-720826424);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(entries) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(decorators) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(keysInBackstack) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(keysInComposition) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      var keysInBackStack = keysInBackstack;
      var latestEntries$delegate = rememberUpdatedState(entries, $composer_0, 14 & $dirty);
      var latestDecorators$delegate = rememberUpdatedState(decorators, $composer_0, 14 & $dirty >> 3);
      // Inline function 'androidx.navigation3.runtime.fastForEachOrForEach' call
      if (isInterface(entries, RandomAccess)) {
        var inductionVariable = 0;
        var last = entries.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = entries.l1(index);
            var contentKey = item.tmu_1;
            keysInBackStack.j1(contentKey);
            var tmp = toList(entries);
            var tmp0 = $composer_0;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid = !!(!!(!!(!!($composer_0.k31(latestEntries$delegate) | $composer_0.q31(contentKey)) | $composer_0.q31(keysInBackStack)) | $composer_0.q31(keysInComposition)) | $composer_0.k31(latestDecorators$delegate));
            // Inline function 'kotlin.let' call
            var it = tmp0.i31();
            var tmp_0;
            if (invalid || it === Companion_getInstance().f30_1) {
              var value = PrepareBackStack$lambda_1(contentKey, keysInBackStack, keysInComposition, latestEntries$delegate, latestDecorators$delegate);
              tmp0.j31(value);
              tmp_0 = value;
            } else {
              tmp_0 = it;
            }
            var tmp$ret$3 = tmp_0;
            DisposableEffect(contentKey, tmp, tmp$ret$3, $composer_0, 0);
          }
           while (inductionVariable <= last);
      } else {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = entries.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          var contentKey_0 = element.tmu_1;
          keysInBackStack.j1(contentKey_0);
          var tmp_1 = toList(entries);
          var tmp0_0 = $composer_0;
          // Inline function 'androidx.compose.runtime.cache' call
          var invalid_0 = !!(!!(!!(!!($composer_0.k31(latestEntries$delegate) | $composer_0.q31(contentKey_0)) | $composer_0.q31(keysInBackStack)) | $composer_0.q31(keysInComposition)) | $composer_0.k31(latestDecorators$delegate));
          // Inline function 'kotlin.let' call
          var it_0 = tmp0_0.i31();
          var tmp_2;
          if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
            var value_0 = PrepareBackStack$lambda_2(contentKey_0, keysInBackStack, keysInComposition, latestEntries$delegate, latestDecorators$delegate);
            tmp0_0.j31(value_0);
            tmp_2 = value_0;
          } else {
            tmp_2 = it_0;
          }
          var tmp$ret$9 = tmp_2;
          DisposableEffect(contentKey_0, tmp_1, tmp$ret$9, $composer_0, 0);
        }
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(PrepareBackStack$lambda_3(entries, decorators, keysInBackstack, keysInComposition, $changed));
    }
  }
  function decorateEntry$lambda($latestDecorators$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('latestDecorators', KProperty0, false);
    return $latestDecorators$delegate.u1();
  }
  function decorateEntry$$inlined$run$1$1$1($keysInComposition, $contentKey, $keysInBackstack, $latestDecorators$delegate) {
    this.wmu_1 = $keysInComposition;
    this.xmu_1 = $contentKey;
    this.ymu_1 = $keysInBackstack;
    this.zmu_1 = $latestDecorators$delegate;
  }
  protoOf(decorateEntry$$inlined$run$1$1$1).s1d = function () {
    var notInComposition = this.wmu_1.d3(this.xmu_1);
    var popped = !this.ymu_1.m1(this.xmu_1);
    if (popped && notInComposition) {
      // Inline function 'androidx.navigation3.runtime.fastForEachReversedOrForEachReversed' call
      var this_0 = decorateEntry$lambda(this.zmu_1);
      if (isInterface(this_0, RandomAccess)) {
        var inductionVariable = this_0.n1() - 1 | 0;
        if (0 <= inductionVariable)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var item = this_0.l1(index);
            item.amv_1(this.xmu_1);
          }
           while (0 <= inductionVariable);
      } else {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = reversed(this_0).t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          element.amv_1(this.xmu_1);
        }
      }
    }
  };
  function decorateEntry$lambda$lambda($keysInComposition, $contentKey, $keysInBackstack, $latestDecorators$delegate) {
    return function ($this$DisposableEffect) {
      $keysInComposition.j1($contentKey);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new decorateEntry$$inlined$run$1$1$1($keysInComposition, $contentKey, $keysInBackstack, $latestDecorators$delegate);
    };
  }
  function decorateEntry$lambda$lambda_0($decorator, $wrappedEntry) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        tmp = $decorator.bmv_1($wrappedEntry, $composer_0, 0);
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function decorateEntry$lambda_0($keysInComposition, $contentKey, $keysInBackstack, $latestDecorators$delegate, $decorators, $entry) {
    return function (it, $composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 17) === 16), $changed & 1)) {
        var keysInComposition = $keysInComposition;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = !!(!!(!!($composer_0.q31(keysInComposition) | $composer_0.q31($contentKey)) | $composer_0.q31($keysInBackstack)) | $composer_0.k31($latestDecorators$delegate));
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_0;
        if (invalid || it_0 === Companion_getInstance().f30_1) {
          var value = decorateEntry$lambda$lambda(keysInComposition, $contentKey, $keysInBackstack, $latestDecorators$delegate);
          $composer_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it_0;
        }
        var tmp$ret$0 = tmp_0;
        DisposableEffect_0($contentKey, tmp$ret$0, $composer_0, 0);
        $composer_0.m30(358947325);
        var tmp0 = fastDistinctOrDistinct($decorators);
        // Inline function 'kotlin.collections.foldRight' call
        var accumulator = $entry;
        if (!tmp0.r()) {
          var iterator = tmp0.p1(tmp0.n1());
          while (iterator.v4()) {
            var tmp0_0 = iterator.x4();
            var wrappedEntry = accumulator;
            // Inline function 'kotlin.run' call
            var dispatchReceiver = rememberComposableLambda(-330823412, true, decorateEntry$lambda$lambda_0(tmp0_0, wrappedEntry), $composer_0, 54);
            // Inline function 'androidx.compose.runtime.remember' call
            var $composer_1 = $composer_0;
            // Inline function 'androidx.compose.runtime.cache' call
            var invalid_0 = $composer_1.k31(dispatchReceiver);
            // Inline function 'kotlin.let' call
            var it_1 = $composer_1.i31();
            var tmp_1;
            if (invalid_0 || it_1 === Companion_getInstance().f30_1) {
              var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
              $composer_1.j31(value_0);
              tmp_1 = value_0;
            } else {
              tmp_1 = it_1;
            }
            var tmp$ret$6 = tmp_1;
            accumulator = NavEntry_init_$Create$(wrappedEntry, tmp$ret$6);
          }
        }
        var tmp0_group = accumulator;
        $composer_0.n30();
        tmp0_group.cmv($composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function PrepareBackStack$lambda($latestEntries$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('latestEntries', KProperty0, false);
    return $latestEntries$delegate.u1();
  }
  function PrepareBackStack$lambda_0($latestDecorators$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('latestDecorators', KProperty0, false);
    return $latestDecorators$delegate.u1();
  }
  function PrepareBackStack$$inlined$fastForEachOrForEach$1$1($contentKey, $keysInBackStack, $keysInComposition, $latestEntries$delegate, $latestDecorators$delegate) {
    this.dmv_1 = $contentKey;
    this.emv_1 = $keysInBackStack;
    this.fmv_1 = $keysInComposition;
    this.gmv_1 = $latestEntries$delegate;
    this.hmv_1 = $latestDecorators$delegate;
  }
  protoOf(PrepareBackStack$$inlined$fastForEachOrForEach$1$1).s1d = function () {
    // Inline function 'androidx.navigation3.runtime.fastMapOrMap' call
    var this_0 = PrepareBackStack$lambda(this.gmv_1);
    var tmp;
    if (isInterface(this_0, RandomAccess)) {
      var target = ArrayList_init_$Create$(this_0.n1());
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          // Inline function 'kotlin.collections.plusAssign' call
          var element = item.tmu_1;
          target.j1(element);
        }
         while (inductionVariable <= last);
      tmp = target;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.t();
      while (_iterator__ex2g4s.u()) {
        var item_0 = _iterator__ex2g4s.v();
        var tmp$ret$9 = item_0.tmu_1;
        destination.j1(tmp$ret$9);
      }
      tmp = destination;
    }
    var latestBackStack = tmp;
    var tmp_0;
    if (!latestBackStack.m1(this.dmv_1)) {
      tmp_0 = this.emv_1.d3(this.dmv_1);
    } else {
      tmp_0 = false;
    }
    var popped = tmp_0;
    if (popped && !this.fmv_1.m1(this.dmv_1)) {
      // Inline function 'androidx.navigation3.runtime.fastForEachReversedOrForEachReversed' call
      var this_1 = PrepareBackStack$lambda_0(this.hmv_1);
      if (isInterface(this_1, RandomAccess)) {
        var inductionVariable_0 = this_1.n1() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            var item_1 = this_1.l1(index_0);
            item_1.amv_1(this.dmv_1);
          }
           while (0 <= inductionVariable_0);
      } else {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = reversed(this_1).t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          element_0.amv_1(this.dmv_1);
        }
      }
    }
  };
  function PrepareBackStack$lambda_1($contentKey, $keysInBackStack, $keysInComposition, $latestEntries$delegate, $latestDecorators$delegate) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new PrepareBackStack$$inlined$fastForEachOrForEach$1$1($contentKey, $keysInBackStack, $keysInComposition, $latestEntries$delegate, $latestDecorators$delegate);
    };
  }
  function PrepareBackStack$$inlined$fastForEachOrForEach$2$1($contentKey, $keysInBackStack, $keysInComposition, $latestEntries$delegate, $latestDecorators$delegate) {
    this.imv_1 = $contentKey;
    this.jmv_1 = $keysInBackStack;
    this.kmv_1 = $keysInComposition;
    this.lmv_1 = $latestEntries$delegate;
    this.mmv_1 = $latestDecorators$delegate;
  }
  protoOf(PrepareBackStack$$inlined$fastForEachOrForEach$2$1).s1d = function () {
    // Inline function 'androidx.navigation3.runtime.fastMapOrMap' call
    var this_0 = PrepareBackStack$lambda(this.lmv_1);
    var tmp;
    if (isInterface(this_0, RandomAccess)) {
      var target = ArrayList_init_$Create$(this_0.n1());
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          // Inline function 'kotlin.collections.plusAssign' call
          var element = item.tmu_1;
          target.j1(element);
        }
         while (inductionVariable <= last);
      tmp = target;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.t();
      while (_iterator__ex2g4s.u()) {
        var item_0 = _iterator__ex2g4s.v();
        var tmp$ret$9 = item_0.tmu_1;
        destination.j1(tmp$ret$9);
      }
      tmp = destination;
    }
    var latestBackStack = tmp;
    var tmp_0;
    if (!latestBackStack.m1(this.imv_1)) {
      tmp_0 = this.jmv_1.d3(this.imv_1);
    } else {
      tmp_0 = false;
    }
    var popped = tmp_0;
    if (popped && !this.kmv_1.m1(this.imv_1)) {
      // Inline function 'androidx.navigation3.runtime.fastForEachReversedOrForEachReversed' call
      var this_1 = PrepareBackStack$lambda_0(this.mmv_1);
      if (isInterface(this_1, RandomAccess)) {
        var inductionVariable_0 = this_1.n1() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            var item_1 = this_1.l1(index_0);
            item_1.amv_1(this.imv_1);
          }
           while (0 <= inductionVariable_0);
      } else {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = reversed(this_1).t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          element_0.amv_1(this.imv_1);
        }
      }
    }
  };
  function PrepareBackStack$lambda_2($contentKey, $keysInBackStack, $keysInComposition, $latestEntries$delegate, $latestDecorators$delegate) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new PrepareBackStack$$inlined$fastForEachOrForEach$2$1($contentKey, $keysInBackStack, $keysInComposition, $latestEntries$delegate, $latestDecorators$delegate);
    };
  }
  function PrepareBackStack$lambda_3($entries, $decorators, $keysInBackstack, $keysInComposition, $$changed) {
    return function ($composer, $force) {
      PrepareBackStack($entries, $decorators, $keysInBackstack, $keysInComposition, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var androidx_navigation3_runtime_EntryProviderScope$stable;
  function fastDistinctOrDistinct(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, RandomAccess)) {
      // Inline function 'androidx.navigation3.runtime.fastDistinctBy' call
      var set = new MutableScatterSet(_this__u8e3s4.n1());
      var target = ArrayList_init_$Create$(_this__u8e3s4.n1());
      // Inline function 'androidx.navigation3.runtime.fastForEach' call
      var inductionVariable = 0;
      var last = _this__u8e3s4.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = _this__u8e3s4.l1(index);
          var key = item;
          if (set.j1(key)) {
            // Inline function 'kotlin.collections.plusAssign' call
            target.j1(item);
          }
        }
         while (inductionVariable <= last);
      tmp = target;
    } else {
      tmp = distinct(_this__u8e3s4);
    }
    return tmp;
  }
  var androidx_navigation3_runtime_NavBackStack$stable;
  var androidx_navigation3_runtime_NavEntry$stable;
  function NavEntry_init_$Init$(navEntry, content, $this) {
    NavEntry.call($this, navEntry.smu_1, navEntry.tmu_1, navEntry.umu_1, content);
    return $this;
  }
  function NavEntry_init_$Create$(navEntry, content) {
    return NavEntry_init_$Init$(navEntry, content, objectCreate(protoOf(NavEntry)));
  }
  function NavEntry$Content$lambda($tmp0_rcvr, $$changed) {
    return function ($composer, $force) {
      $tmp0_rcvr.cmv($composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function NavEntry(key, contentKey, metadata, content) {
    contentKey = contentKey === VOID ? defaultContentKey(key) : contentKey;
    metadata = metadata === VOID ? emptyMap() : metadata;
    this.smu_1 = key;
    this.tmu_1 = contentKey;
    this.umu_1 = metadata;
    this.vmu_1 = content;
  }
  protoOf(NavEntry).cmv = function ($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(295512821);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(this) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      this.vmu_1(this.smu_1, $composer_0, 0);
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(NavEntry$Content$lambda(this, $changed));
    }
  };
  protoOf(NavEntry).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NavEntry))
      THROW_CCE();
    return equals(this.smu_1, other.smu_1) && equals(this.tmu_1, other.tmu_1) && equals(this.umu_1, other.umu_1) && this.vmu_1 === other.vmu_1;
  };
  protoOf(NavEntry).hashCode = function () {
    return ((imul(hashCode(this.smu_1), 31) + imul(hashCode(this.tmu_1), 31) | 0) + imul(hashCode(this.umu_1), 31) | 0) + imul(hashCode(this.vmu_1), 31) | 0;
  };
  protoOf(NavEntry).toString = function () {
    return 'NavEntry(key=' + toString(this.smu_1) + ', contentKey=' + toString(this.tmu_1) + ', metadata=' + toString(this.umu_1) + ', content=' + toString(this.vmu_1) + ')';
  };
  function defaultContentKey(key) {
    return toString(key);
  }
  var androidx_navigation3_runtime_NavEntryDecorator$stable;
  function NavEntryDecorator$_init_$lambda_48xc2p(it) {
    return Unit_instance;
  }
  function NavEntryDecorator(onPop, decorate) {
    var tmp;
    if (onPop === VOID) {
      tmp = NavEntryDecorator$_init_$lambda_48xc2p;
    } else {
      tmp = onPop;
    }
    onPop = tmp;
    this.amv_1 = onPop;
    this.bmv_1 = decorate;
  }
  var androidx_navigation3_runtime_MetadataScope$stable;
  function get(_this__u8e3s4, key) {
    var tmp = _this__u8e3s4.w2(toString(key));
    return !(tmp == null) ? tmp : null;
  }
  var androidx_navigation3_runtime_SaveableStateHolderNavEntryDecorator$stable;
  function SaveableStateHolderNavEntryDecorator$_init_$lambda_xd9wjf($saveableStateHolder) {
    return function (contentKey) {
      $saveableStateHolder.y7o(contentKey);
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_0(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      p0.u50(p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 18, VOID, [p0]);
  }
  function SaveableStateHolderNavEntryDecorator$_init_$lambda$lambda_7o75ao($entry) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        $entry.cmv($composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposableLambda$invoke$ref_1(p0) {
    return constructCallableReference(function (p0_0, p1) {
      p0.t50(p0_0, p1);
      return Unit_instance;
    }, 2, 0, 17, VOID, [p0]);
  }
  function SaveableStateHolderNavEntryDecorator$_init_$lambda_xd9wjf_0($saveableStateHolder) {
    return function (entry, $composer, $changed) {
      var $composer_0 = $composer;
      var $dirty = $changed;
      var tmp;
      if (($changed & 6) === 0) {
        $dirty = $dirty | ($composer_0.k31(entry) ? 4 : 2);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(121262920, true, SaveableStateHolderNavEntryDecorator$_init_$lambda$lambda_7o75ao(entry), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance().f30_1) {
          var value = ComposableLambda$invoke$ref_1(dispatchReceiver);
          $composer_1.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp$ret$0 = tmp_1;
        $saveableStateHolder.x7o(entry.tmu_1, tmp$ret$0, $composer_0, 48);
        tmp_0 = Unit_instance;
      } else {
        $composer_0.z30();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SaveableStateHolderNavEntryDecorator(saveableStateHolder) {
    var tmp = SaveableStateHolderNavEntryDecorator$_init_$lambda_xd9wjf(saveableStateHolder);
    NavEntryDecorator.call(this, tmp, ComposableLambda$invoke$ref_0(composableLambdaInstance(-1320822745, true, SaveableStateHolderNavEntryDecorator$_init_$lambda_xd9wjf_0(saveableStateHolder))));
  }
  function rememberSaveableStateHolderNavEntryDecorator(saveableStateHolder, $composer, $changed, $default) {
    var saveableStateHolder_0 = saveableStateHolder;
    var $composer_0 = $composer;
    if (!(($default & 1) === 0))
      saveableStateHolder_0 = rememberSaveableStateHolder($composer_0, 0);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.k31(saveableStateHolder_0);
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = new SaveableStateHolderNavEntryDecorator(saveableStateHolder_0);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  var androidx_navigation3_runtime_serialization_NavBackStackSerializer$stable;
  //region block: init
  androidx_navigation3_runtime_EntryProviderScope$stable = 8;
  androidx_navigation3_runtime_NavBackStack$stable = 0;
  androidx_navigation3_runtime_NavEntry$stable = 0;
  androidx_navigation3_runtime_NavEntryDecorator$stable = 0;
  androidx_navigation3_runtime_MetadataScope$stable = 8;
  androidx_navigation3_runtime_SaveableStateHolderNavEntryDecorator$stable = 0;
  androidx_navigation3_runtime_serialization_NavBackStackSerializer$stable = 8;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = NavEntryDecorator;
  _.$_$.b = NavEntry;
  _.$_$.c = get;
  _.$_$.d = rememberDecoratedNavEntries;
  _.$_$.e = rememberDecoratedNavEntries_0;
  _.$_$.f = rememberSaveableStateHolderNavEntryDecorator;
  //endregion
  return _;
}));

//# sourceMappingURL=androidx-navigation3-navigation3-runtime.js.map
